module.exports = __webpack_public_path__ + "img/W-SDR-11.7927fb03.jpg";